import { ModalStatusAssinaturaComponent } from './../../components/modal-status-assinatura/modal-status-assinatura.component';
import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { MDBModalRef, MDBModalService } from "ng-uikit-pro-standard";
import { NotificationService } from "src/app/shared/services/notification.service";
import { Processos, StatusProcesso } from "../../models/processos.model";
import { SolicitacoesUsuario } from "../../models/solicitacoes.model";
import { PerfilService } from "../../services/perfil.service";
import { Empresa } from 'src/app/auth/models/empresa.model';
import { encryptStorage } from "../../../auth/utils/storage";

import Swal from "sweetalert2";
import {
  showDefaultError,
  showError,
  showNotification,
  showSucess,
} from "src/app/shared/utils/functions/notification.function";
import { safeAsign } from "src/app/shared/utils/functions/safe-asign.function";
import { generateUUID } from "src/app/shared/utils/functions/codigo-transacao.model";
import { ModalEditarDadosComponent } from "../../components/modal-editar-dados/modal-editar-dados.component";
import { HttpErrorResponse } from "@angular/common/http";
import { ModalEditarRepresentanteComponent } from "../../components/modal-editar-representante/modal-editar-representante.component";

@Component({
  selector: "app-home-investidor",
  templateUrl: "./home-investidor.component.html",
  styleUrls: ["./home-investidor.component.scss"],
})
export class HomeInvestidorComponent implements OnInit, OnDestroy {
  modalRef: MDBModalRef;

  rows: any[] = [];
  solicitacoes: Processos[] = [];
  cardSolicitacoes: any[] = [];

  modalCloseEvent: any;
  editaRepresentantes: any;

  constructor(
    private perfilService: PerfilService,
    private router: Router,
    private modalService: MDBModalService,
    private route: ActivatedRoute,
  ) {}




  ngOnInit(): void {
    this.listarSolicitacoes();

    this.modalCloseEvent = this.modalService.closed.subscribe(
      (modalWasClosed) => this.listarSolicitacoes()
    );
  }

  ngOnDestroy(): void {
    this.modalCloseEvent.unsubscribe();
  }

  listarSolicitacoes() {
     this.perfilService.consultaSolicitacoes().subscribe(
      (res) => {
      this.solicitacoes = res["data"]["processos"]
    },

      (e) => {
        if (e.status == 500) {
          return showError("", e.statusText);
        }

        return showDefaultError(e);
      },
      () =>{
        this.formatarPayload(this.solicitacoes)
      }
    );

  }

  formatarPayload(solicitacoes: Processos[]) {
    this.cardSolicitacoes = [];
    solicitacoes.forEach((card) => {
      card.statusProcesso.forEach((statusProcesso) => {
        statusProcesso["nomeInstituicao"] = card.nomeInstituicao;
        statusProcesso["dataLiquidacao"] = card.dataLiquidacao;
        statusProcesso["id"] = card.id;
        statusProcesso["aguardandoDadosDaInstituicao"] = card.aguardandoDadosDaInstituicao;
        statusProcesso["nomeEmpresa"] = card.nomeEmpresa;
        statusProcesso["cnpjEmpresa"] = card.cnpjEmpresa;
        this.cardSolicitacoes.push(statusProcesso);
      });
    });
  }

  exibirAlerta(idAlerta) {
    switch (idAlerta) {
      case 1: {
        //Alerta de Pagamento Efetivado
        showSucess(
          "Pagamento Efetivado", // Title
          "", //Text
          "<p>O processo de pagamento de garantia referente a esta Instituição Financeira foi concluído.</p>" //Title
        );
        break;
      }
      case 2: {
        //Alerta para pagamento Concluido
        showSucess(
          "Pagamento Concluído", // Title
          "", //Text
          "<p>Pagamento Concluído. Consulte a área de histórico de pagamentos para mais detalhes !</p>" //Title
        );
        break;
      }
      case 3: {
        return Swal.fire({
          title: "",
          text:
            "A Instituição Financeira em Regime Especial," + //Text
            "enviará ao FGC os dados de seus depositantes. Assim que recebermos os referidos dados, " +
            "será possível realizar a solicitação",
          iconHtml:
            '<img style="width: 60px" src="../../../../assets/icons/report.svg" alt="">',
        });
        break;
      }
      case 4: {
        //Alerta Termo
        showSucess(
          "", // Title
          "", //Text
          "<p>O termo de cessão e sub-rogação de créditos foi gerado. As orientações de pagamento serão encaminhadas para o e-mail cadastrado.</p>" //Title
        );
        break;
      }
      case 5: {
        //Alerta Anuência
        showSucess(
          "", // Title
          "", //Text
          "<p>Sua solicitação foi concluída e está aguardando a anuência da corretora, assim que o FGC receber a informação da corretora, o termo de cessão será gerado e as orientações de pagamento serão enviadas para o e-mail cadastrado.</p>" //Title
        );
        break;
      }
      case 6: {
        //Alerta Solicitacão Concluída
        showSucess(
          "Solicitação Concluída", // Title
          "", //Text
          "<p>Sua solicitação foi concluída e está em processo de análise, estando em conformidade com as informações da Instituição Financeira, " +
            "o termo de cessão será gerado e as orientações de pagamento serão enviadas para o e-mail cadastrado.</p>" //Title
        );
        break;
      }
      case 7: {
        //Alerta Praça
        showSucess(
          "",
          "",
          "<p>Sua solicitação foi concluída, o termo de cessão e sub-rogação de créditos foi gerado e será encaminhado ao seu e-mail cadastrado com orientações sobre os próximos passos.</p>"
        );
      }
    }
  }

  exibirMensagem(codigoStatus, tipoProcesso, idInvestidor) {
    if (!safeAsign(codigoStatus) && !safeAsign(tipoProcesso)) {
      // console.log('erro api retornando null')
      return showError(
        "Ocorreu um erro",
        "Houve um erro ao processar a sua solicitação, tente novamente mais tarde."
      );
    }

    //Status Processo = codigo status
    //Tipo Processo = Tipo Processo

    let paramAlterar = tipoProcesso == 4 && codigoStatus == 6 ? "ALTERAR" : "";

    switch (paramAlterar) {
      case "ALTERAR": {
        this.showModal(idInvestidor);
        break;
      }
      default: {
        let query = {
          stProcesso: codigoStatus,
          tpProcesso: tipoProcesso,
          codigoTransacao: generateUUID(),
        };

        this.perfilService.acompanharProcessoSolicitacao(query).subscribe(
          (res) => showNotification("", res["data"]["mensagem"]),
          (e) => showDefaultError(e)
        );
      }
    }
  }

  solicitarGarantia(id, nomeEmpresa, cnpjEmpresa, nome, data, aguardandoDados, exibirRepresentantes) {
    if (aguardandoDados != 2) {
      return this.exibirAlerta(3); // Alerta de aguardando solicitação
    }
    this.router.navigate(["/spg/solicita-garantia", id, nomeEmpresa, cnpjEmpresa, nome, data, exibirRepresentantes]);
    // return this.perfilService.consultaDisponibilidade(id).subscribe(
    //   (res) => {
    //     this.router.navigate(["/spg/solicita-garantia", id, nome, data]);
    //   },
    //   (e) => {
    //     if (e.status == 422) {
    //       return showDefaultError(e);
    //     }
    //     return showError(
    //       "",
    //       "Ocorreu um erro na solicitação, por favor tente novamente em alguns instantes” e permanecer na tela atual."
    //     );
    //   }
    // );
  }

  realizarAcao(cardData){
    const isSolicitar = cardData.tipoProcesso == 1 && cardData.statusProcesso == 1;
    const isCorrecao = cardData.tipoProcesso == 4 && cardData.statusProcesso == 6;
    const isCorrigirInformacoes = cardData.tipoProcesso == 4 && cardData.statusProcesso == 24;
    const isAceitarTermo = cardData.tipoProcesso == 3 && cardData.statusProcesso == 25;
    const isPedidoAndamento = cardData.tipoProcesso == 1 && cardData.statusProcesso == 3;

    if(isSolicitar || isCorrecao){
      this.solicitarGarantia(cardData.id, cardData.nomeEmpresa, cardData.cnpjEmpresa, cardData.nomeInstituicao, cardData.dataLiquidacao, cardData.aguardandoDadosDaInstituicao, isSolicitar)
      return;
    }

    if(isCorrigirInformacoes){
      this.openModalEditar(cardData);
      return;
    }

    if(isAceitarTermo || isPedidoAndamento){
      this.openModalStatus(cardData.id);
      return;
    }

    this.exibirMensagem(cardData.statusProcesso,cardData.tipoProcesso, cardData.id)
  }

  openModalEditar(cardData){

    const cpfResponsavel = encryptStorage.getItem(
      "@documentoIdentificador"
    );

    this.perfilService
      .listarEmpresa(cardData.cnpjEmpresa, cpfResponsavel)
      .subscribe(
        (res) => {
          const empresa = res["data"] as Empresa;
          this.editaRepresentantes = res.data.editaRepresentantes;

          let config = {
            scroll: true,
            ignoreBackdropClick: true,
            data:{
              empresa: empresa,
              cpfResponsavel: cpfResponsavel,
              idPedido: cardData.id,
              editaRepresentantes: this.editaRepresentantes
            }
          };
          this.modalRef = this.modalService.show(ModalEditarRepresentanteComponent, config);
        },
        (e) => {
          showError("", "Erro ao buscar dados da empresa.");
        }
    );
  }

  showModal(dados) {
    let config = {
      scroll: true,
      ignoreBackdropClick: true,
      data: { idInvestidor: dados, garantiaOrdinaria: true },
    };

    this.modalRef = this.modalService.show(ModalEditarDadosComponent, config);
  }

  openModalStatus(cardData) {
    let config = {
      scroll: true,
      ignoreBackdropClick: true,
      data: { id: cardData },
    };

    this.modalRef = this.modalService.show(ModalStatusAssinaturaComponent, config);
  }

  exibirButton(status) {
    switch (status) {
      case 1: {
        return;
      }
      case 2: {
        return true;
      }
      case 3: {
        return true;
      }
      case 4: {
        return true;
      }
      case 5: {
        return true;
      }
      case 6: {
        return true;
      }
      case 7: {
        return true;
      }
      case 8: {
        return true;
      }
      case 9: {
        return true;
      }
      case 10: {
        return true;
      }
      case 11: {
        return true;
      }
      case 12: {
        return true;
      }
      case 15: {
        return true;
      }
      case 13: {
        return true;
      }
      case 16: {
        return true;
      }
      case 17: {
        return true;
      }
      case 20: {
        return true;
      }
      case 21: {
        return true;
      }
      case 24: {
        return true;
      }
      case 38: {
        return true;
      }

      default: {
        return true;
      }
    }

    return false;
  }
  customButtonStyle(status) {
    switch (status) {
      case 1: {
        return "btn btnCompletarSolicitacao";
      }
      case 2: {
        return "btn";
      }
      case 3: {
        return "btn";
      }
      case 4: {
        return "btn";
      }
      case 5: {
        return "btn";
      }
      case 6: {
        return "btn";
      }
      case 7: {
        return "btn";
      }
      case 8: {
        return "btn btnAcompanharProcesso";
      }
      case 9: {
        return "btn btnPagamentoProcessamento";
      }
      case 10: {
        return "btn btnAssinarTermo";
      }
      case 12: {
        return "btn";
      }
      case 13: {
        return "btn";
      }
      case 15: {
        return "btn btnPagamentoAprovado";
      }
      case 16: {
        return "btn btn-gray";
      }
      case 20: {
        return "btn btn-gray";
      }

      case 17: {
        return "btn";
      }
      case 11: {
        return "btn btnPagamentoAprovado";
      }
      case 21: {
        return "btn btnPedidoIndisponivel";
      }
      case 24: {
        return "btn btnCorrigirInformacoes";
      }
      case 38: {
        return "btn btnAcompanharProcesso";
      }
      default: {
        return "btn";
      }
    }

    return "btn";
  }
}
